import { fetchSchema } from '../api/employees';

const state = {
    schema: {},
    users: [],
};

const getters = {};

const mutations = {
    SET_SCHEMA(state, schema = {}) {
        state.schema = Object.freeze(schema);
    },
};

const actions = {
    async fetchSchema({ commit }) {
        commit('SET_SCHEMA', await fetchSchema());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
